import React from 'react';

import {BackNavigation} from './components';
import styles from './Header.module.scss';
import {useLocation} from 'react-router';

export interface Props {
  children: React.ReactNode;
}

export default function Header({children}: Props) {
  const location = useLocation();

  return (
    <div className={styles.Header}>
      <div className={styles.LeftWrapper}>
        {location.pathname === '/settings' ||
          (location.pathname.includes('/search') && <BackNavigation />)}
        {children}
      </div>
    </div>
  );
}
